<template>
  <div>
    <el-dialog
      :model-value="sceneVideoUploadDialogVisible"
      title="先记录人工修改说明"
      width="560px"
      destroy-on-close
      @update:model-value="emit('update:sceneVideoUploadDialogVisible', $event)"
    >
      <div class="scene-video-upload-dialog">
        <p>上传人工处理视频前，先记录本次修改了哪些点，便于后续学习和复盘。</p>
        <el-input
          :model-value="sceneVideoUploadFeedbackDraft"
          type="textarea"
          :rows="5"
          maxlength="1000"
          show-word-limit
          placeholder="例如：第 1 镜头优化了人物表情与运镜节奏，并替换了更稳定的灯光氛围。"
          @update:model-value="emit('update:sceneVideoUploadFeedbackDraft', $event)"
        />
      </div>
      <template #footer>
        <div class="scene-video-upload-dialog__actions">
          <el-button @click="emit('cancel-scene-video-upload-dialog')">取消</el-button>
          <el-button type="primary" @click="emit('confirm-scene-video-upload-dialog')">继续上传视频</el-button>
        </div>
      </template>
    </el-dialog>

    <transition name="workspace-global-loading-fade">
      <div v-if="isWorkspaceBusy" class="workspace-global-loading" aria-live="polite" aria-busy="true">
        <div class="workspace-global-loading__backdrop"></div>
        <div class="workspace-global-loading__panel">
          <div class="workspace-global-loading__spinner" aria-hidden="true"></div>
          <div class="workspace-global-loading__content">
            <span class="workspace-global-loading__eyebrow">系统处理中</span>
            <strong>{{ workspaceBusyTitle }}</strong>
            <p>{{ workspaceBusyDescription }}</p>
            <small>{{ workspaceBusyStageLabel }}</small>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  sceneVideoUploadDialogVisible: boolean
  sceneVideoUploadFeedbackDraft: string
  isWorkspaceBusy: boolean
  workspaceBusyTitle: string
  workspaceBusyDescription: string
  workspaceBusyStageLabel: string
}>()

const emit = defineEmits<{
  (event: 'update:sceneVideoUploadDialogVisible', value: boolean): void
  (event: 'update:sceneVideoUploadFeedbackDraft', value: string): void
  (event: 'cancel-scene-video-upload-dialog'): void
  (event: 'confirm-scene-video-upload-dialog'): void
}>()

void props
</script>

<style scoped>
.workspace-global-loading {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: grid;
  place-items: center;
  padding: 24px;
}

.workspace-global-loading__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(248, 250, 252, 0.72);
  backdrop-filter: blur(8px);
}

.workspace-global-loading__panel {
  position: relative;
  z-index: 1;
  width: min(520px, calc(100vw - 32px));
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 18px;
  align-items: center;
  padding: 24px 26px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.14);
}

.workspace-global-loading__spinner {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  border: 4px solid rgba(59, 130, 246, 0.16);
  border-top-color: #2563eb;
  border-right-color: #14b8a6;
  animation: workspace-spin 0.8s linear infinite;
}

.workspace-global-loading__content {
  display: grid;
  gap: 8px;
}

.workspace-global-loading__eyebrow {
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.workspace-global-loading__content strong {
  color: #0f172a;
  font-size: 24px;
}

.workspace-global-loading__content p {
  margin: 0;
  color: #64748b;
  line-height: 1.75;
}

.workspace-global-loading__content small {
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 700;
}

.workspace-global-loading-fade-enter-active,
.workspace-global-loading-fade-leave-active {
  transition: opacity 0.18s ease;
}

.workspace-global-loading-fade-enter-from,
.workspace-global-loading-fade-leave-to {
  opacity: 0;
}

@keyframes workspace-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.scene-video-upload-dialog {
  display: grid;
  gap: 14px;
}

.scene-video-upload-dialog p {
  margin: 0;
  color: #64748b;
  line-height: 1.7;
}

.scene-video-upload-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
